import { FormattedCurrency } from '@iwIntlProvider/FormattedCurrency';
import { IconRocket } from '@iwoca/icons';
import { Button } from '@iwoca/orion';
import { H2 } from '@ui';
import classNames from 'classnames';
import { FormattedDate, FormattedMessage } from 'react-intl';

import messages from './Alerts.messages';
import { Rate } from '../../../../ui/rate';
import { TTopUpStatus } from '../../NewOutstandingView.helpers';

export const InterestOnlyExtensionApprovedAlert = ({
    topUpStatus,
    onClick,
    approvalAmount,
    interestRate,
    timeoutDate
}: {
    topUpStatus: TTopUpStatus;
    onClick: () => void;
    approvalAmount: number;
    interestRate: number;
    timeoutDate: string;
}) => {
    const renderDescription = () => {
        switch (topUpStatus) {
            case 'INTEREST_ONLY_EXTENSION_APPROVED':
                return (
                    <FormattedMessage
                        {...messages.interestOnlyExtensionDescription}
                        values={{
                            interestRate: <Rate value={interestRate} />,
                            timeoutDate: (
                                <FormattedDate
                                    value={timeoutDate}
                                    day="2-digit"
                                    month="short"
                                    year="numeric"
                                />
                            )
                        }}
                    />
                );
            case 'INTEREST_ONLY_EXTENSION_APPROVED_WITH_MORE_FUNDS':
                return (
                    <FormattedMessage
                        {...messages.interestOnlyExtensionWithFundsDescription}
                        values={{
                            amount: (
                                <FormattedCurrency value={approvalAmount} />
                            ),
                            interestRate: <Rate value={interestRate} />,
                            timeoutDate: (
                                <FormattedDate
                                    value={timeoutDate}
                                    day="2-digit"
                                    month="short"
                                    year="numeric"
                                />
                            )
                        }}
                    />
                );
            default:
                return null;
        }
    };

    return (
        <div
            data-testid="topup-approved-banner-redesign"
            className={classNames(
                'flex items-start gap-s rounded-m bg-gradient-to-t from-success-drk to-success-mid p-m min-sm:gap-l min-sm:p-l'
            )}
        >
            <IconRocket className="mt-xs size-xl shrink-0 fill-structure-100" />
            <div className="space-y-m">
                <div className="space-y-s min-sm:space-y-xs">
                    <H2 className="text-m font-bold text-structure-100">
                        <FormattedMessage {...messages.approvedTitle} />
                    </H2>
                    <p
                        data-testid="approved-alert-description"
                        className="m-0 font-reg text-white"
                    >
                        {renderDescription()}
                    </p>
                </div>

                <Button variant="secondary-alt" onClick={onClick}>
                    <FormattedMessage {...messages.interestOnlyExtendCta} />
                </Button>
            </div>
        </div>
    );
};
